import { EmailDeliveryStatus } from 'src/api';

export const EmailTrackerTableFilterId = {
  toEmail: 'toEmail',
  status: 'status',
} as const;

export const EMAIL_DELIVERY_STATUS_LABEL_MAP: Record<EmailDeliveryStatus, string> = {
  [EmailDeliveryStatus.Delivered]: 'Delivered',
  [EmailDeliveryStatus.NotDelivered]: 'Not Delivered',
  [EmailDeliveryStatus.Processing]: 'Processing',
};
